<template lang="pug">
    v-layout(row wrap)
        v-flex(md6)
        v-flex(md6)
            v-text-field(v-model='search' append-icon='search' label='Buscar' single-line='' hide-details='')
        v-flex(md12)
            v-data-table.elevation-1( v-model="selected" :headers='headers' :items='items' :pagination.sync='pagination'  item-key='id' :search='search')
                template(slot='headers' slot-scope='props')
                    tr
                        th
                            v-checkbox(:input-value='props.all' :indeterminate='props.indeterminate' primary='' hide-details='' @click.stop='toggleAll')
                        th(v-for='header in props.headers' :key='header.text' :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click='changeSort(header.value)')
                            v-icon(small='') arrow_upward
                            |             {{ header.text }}
                template(slot='items' slot-scope='props')
                    tr(:active="props.selected"  @click='props.selected = !props.selected')
                        td
                            v-checkbox(:input-value='props.selected' primary='' hide-details='')
                        //- td.text-xs-center( v-for="header in headers" ) {{ props.item[header.value] | mixThousandSeparatorFormat}}
                        td.text-xs-center {{props.item.emission_date}}
                        td.text-xs-center {{props.item.number}}
                        td.text-xs-center {{props.item.document}}
                        td.text-xs-center ${{props.item.receivable |mixThousandSeparatorFormat}}
                        td.text-xs-center {{props.item.pay_date}}



</template>

<script>
/* mixins */
import TextFormatting from '@/mixins/reusable_mixins/TextFormatting'
export default {
    name: 'invoice-table',
    props: {
        items: {
            type: Array,
            require: true,
        },
        headers: {
            type: Array,
            require: true,
        },
    },
    data: function() {
        return {
            pagination: {
                sortBy: 'emission_date',
            },
            search:'',
            selected: [],
        }
    },
    computed: {},
    methods: {
        /**
         * 
         */
        toggleAll() {
            if (this.selected.length) this.selected = []
            else this.selected = this.items.slice()
        },
        /**
         * 
         */
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
        /* 
         */
        cleanSelectedItems(){
            this.selected = []
        },
        /**
         * 
         */
        // setInvoicesSelected(invoice){
        //     // this.selected.push(invoice)
        //     console.log(this.selected.length,'selected size')
        //     let longInvoices   = (parseInt( this.selected.length )) 
        //                             ? this.selected.length
        //                             : 0
        //     this.selected[longInvoices]= invoice
        //     // if(longInvoices == 0) //nada seleccionada previamente
        //     // {
        //     //     this.selected[]
        //     // }
            
        // },
        /**
         * 
         */
        getInvoicesSelected(){
            return this.selected
        }
    },
    watch: {
            selected(newInvoice){
                if( newInvoice ){
                    this.$emit('invoiceSelected',this.getInvoicesSelected())
                }
            }
    },
    components: {},
    mixins: [TextFormatting],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    updated: function(){
        //this.selected = []
    },
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    .checkStyle{
        margin-left: -30px,
    }
</style>
